import {getCatalogBtn} from "./helper/helpers";
import useToggleCart from "./hooks/useToggleCart";
import {CatalogContext} from "./catalog_context";
import { CartAnmButton } from "./cart_button";

const renewAddonText = gettext("Click here to renew this addon");
const renewTransText = gettext("Renew");
const renewingText = gettext("Renewing");
const renewFreeText = gettext("Renew for free");
const expiryText = gettext("Expiration Date");
const purchaseText = gettext("Purchased");
const isLoadingText = gettext('Loading...');
const catalogData = catalogModule.catalogData;

const RenewButton = (props) => {
    const ctxCatalog = React.useContext(CatalogContext);
    const { catalog_data } = ctxCatalog;
    let product = props.product;
    const {formAttr, isLoading, isProductOwned, toggleCart, removeFromAcct} = useToggleCart(props.product, props);
    const hasOwnedPckg = catalogData.hasOwnProperty("owned_package_key") && catalogData.owned_package_key.indexOf("plan") > 0;
    const hasOwnedPckgInfo = catalogData.hasOwnProperty("owned_package_info") && catalogData.owned_package_info.hasOwnProperty("key") && catalogData.owned_package_info.key.indexOf("plan") > 0;
    const isPkgFree = product.type !== "free" && product.hasOwnProperty("included_in_pkg") && product.included_in_pkg !== "not_included";
    let isPurchased = props.isPurchased;
    let renewButton;
    let renewText;
    let purchasedButton;
    const productButton = getCatalogBtn();
    if(product.type === 'subscription'){
        if (product.included_in_pkg !== "not_included" &&
            (hasOwnedPckg || hasOwnedPckgInfo)
        ){
            renewText = renewFreeText;
        } else {
            renewText = renewTransText;
        }
    } else {
        renewText = renewTransText;
    }
    if (product.status === "renewing") {
        renewButton = <div className="subscription_expiration_date color_red">{renewingText}</div>;
    } else {
        if(catalog_data.app_theme === "manager"){
            renewButton = <button onClick={toggleCart}
                                  title={renewAddonText}
                                  className={formAttr.btn} disabled={isLoading}>
                {isLoading && <div className="spinner-border spinner-border-sm mr-1" role="status"></div>}
                <span className="cart">{formAttr.status === "remove" ? !isLoading && formAttr.text : !isLoading && renewText}</span>
                <span className="cart">{isLoading && isLoadingText}</span>
            </button>;
        } else {
            renewButton = <button addon_key={product.key}
                                  addon_name={product.name}
                                  onClick={() => beforeRenewMethod(this, product.key)}
                                  title={renewAddonText}
                                  className={productButton}>
                <span className="cart">{renewText}</span>
            </button>;
        }
    }
    var product_expiration = new Date(product.expiration_date_ts * 1000);
    var date_str = product_expiration.toLocaleDateString();
    if(catalog_data.app_theme === "manager"){
        // console.log("isPkgFree", isPkgFree)
        if(isPkgFree){
            // console.log("isProductOwned", isProductOwned)
            if(isProductOwned){
                purchasedButton = <CartAnmButton onToggleCart={removeFromAcct} formAttr={formAttr} isLoading={isLoading} />;
            } else {
                purchasedButton = <CartAnmButton onToggleCart={toggleCart} formAttr={formAttr} isLoading={isLoading} />
            }
        } else {
            if(isProductOwned && product.type === "free"){
                purchasedButton = <CartAnmButton onToggleCart={removeFromAcct} formAttr={formAttr} isLoading={isLoading} />;
            } else {
                purchasedButton = <CartAnmButton onToggleCart={toggleCart} formAttr={formAttr} isLoading={isLoading} />;
            }
        }

        // if(isProductOwned && product.type === "free"){
        //     purchasedButton = <CartAnmButton onToggleCart={isProductOwned ? removeFromAcct : toggleCart} formAttr={formAttr} isLoading={isLoading} />;
        // } else if(isProductOwned && product.type === "subscription"){
        //     purchasedButton = <button disabled className={`${productButton} purchased`} type="button" name="submit">{purchaseText}</button>;
        // } else if (isProductOwned && product.type === "non-consumable"){
        //     purchasedButton = <button disabled className={`${productButton} purchased`} type="button" name="submit">{purchaseText}</button>;
        // } else {
        //     purchasedButton = <CartAnmButton onToggleCart={toggleCart} formAttr={formAttr} isLoading={isLoading} />;
        // }
    } else {
        if(isPurchased){
            purchasedButton = <button disabled className={`${productButton} purchased`} type="button" name="submit">{purchaseText}</button>;
        } else {
            purchasedButton = renewButton;
        }
    }
    let renderExpiredText
    if(catalog_data.app_theme !== "manager"){
        renderExpiredText = <div className="subscription_expiration_date color_red">{ expiryText } : {date_str}</div>
    }
    return (
        <React.Fragment>
            {renderExpiredText}
            { purchasedButton }
        </React.Fragment>
    )
};

export default RenewButton;
